import { useI18nContextValue, i18nContext } from './context';

export interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const value = useI18nContextValue();
  return <i18nContext.Provider value={value}>{children}</i18nContext.Provider>;
}
